define.alias("shared/components/shared/ui/report/share", "calendar/components/shared/ui/report/share");